import React from "react";
import { observer } from "owa-mobx-react";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isCapabilityEnabled } from "owa-capabilities";
import { bleedThroughCapability } from "owa-capabilities-definitions/lib/bleedThroughCapability";
import { makeStyles, mergeClasses } from "@fluentui/react-components";

/**
 * Root element for the Ribbon that conditionally applies different styles based on:
 * - Fluent UI v9 flight: `mon-ribbon-fluent-v9-ribbon`
 * - Reading Pane Denseless flight: `rp-denseless`
 * - theme with bleed-through capability
 * - being in a Dialog
 * - being in a Popout
 */
export const RibbonRoot: React.FC<{
    children: React.ReactNode;
    isInDialog?: boolean;
    isInPopout?: boolean;
}> = observer(({ children, isInDialog, isInPopout }) => {
    const isFluentV9Enabled = isGlobalFeatureEnabled("mon-ribbon-fluent-v9-ribbon");
    const isRPDenselessEnabled = isGlobalFeatureEnabled("rp-denseless");
    const isBleedThroughEnabled = isCapabilityEnabled(bleedThroughCapability);
    
    const { root, rootV9, rootV9BleedThrough, denselessPopout, rootDenseless } = useStyles();
    
    return (<div id="RibbonRoot" className={mergeClasses(root, isFluentV9Enabled && !isInDialog && rootV9, isFluentV9Enabled && !isInDialog && isBleedThroughEnabled && rootV9BleedThrough, isFluentV9Enabled &&
            !isInDialog &&
            !isBleedThroughEnabled &&
            isRPDenselessEnabled &&
            !isInPopout &&
            rootDenseless, isFluentV9Enabled &&
            !isInDialog &&
            isRPDenselessEnabled &&
            isInPopout &&
            denselessPopout)}>
            {children}
        </div>);
}, "RibbonRoot");

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
    },
    rootV9: {
        boxSizing: "border-box",
        padding: "0 19px 0 4px",
        width: "100%",
    },
    rootV9BleedThrough: {
        padding: "0 4px",
    },
    rootDenseless: {
        padding: "0 0 0 8px",
        width: "100%",
    },
    denselessPopout: {
        boxSizing: "border-box",
        padding: "0 18px",
        width: "100%",
    },
});
